import { PLATFORM_RULES } from '@thinknet-gmbh/platform-common';

export const PLATFORM_RULES_VALUES = Object.values(PLATFORM_RULES);
